export default function formatProjectRole(role: string) {
  switch (role) {
    case "accessAllProjects":
      return "No access";
    case "project.admin":
      return "Admin";
    case "project.contributor":
      return "Contributor";
    case "project.viewer":
      return "Viewer";
    default:
      return role;
  }
}
